<div class="callback-loading">
    <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
</div>
